import { render, staticRenderFns } from "./TreesFive.vue?vue&type=template&id=664b8997&scoped=true"
var script = {}
import style0 from "./TreesFive.vue?vue&type=style&index=0&id=664b8997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b8997",
  null
  
)

export default component.exports